// extracted by mini-css-extract-plugin
export var divider = "_xh-0";